import { createContext, useEffect, useContext, useMemo } from 'react';
import { MEASURE_MARK_NAMES } from '../../utils/performanceTracking';
import { useFetchCurrentView } from 'framework-listing-lib/internal/ViewTabs/hooks/useFetchViews';
import usePerformanceTracking from '../../hooks/usePerformanceTracking';
import { jsx as _jsx } from "react/jsx-runtime";
const CurrentViewContext = /*#__PURE__*/createContext(null);
export default function CurrentViewProvider({
  children
}) {
  const viewsPerformanceTracking = usePerformanceTracking(MEASURE_MARK_NAMES.VIEWS);
  const {
    currentView,
    loading
  } = useFetchCurrentView();
  useEffect(() => {
    if (loading) {
      return;
    }
    viewsPerformanceTracking.markTimeEnd();
  }, [loading, viewsPerformanceTracking]);
  const value = useMemo(() => {
    return {
      currentView,
      loading
    };
  }, [currentView, loading]);
  return /*#__PURE__*/_jsx(CurrentViewContext.Provider, {
    value: value,
    children: children
  });
}
export function useCurrentViewContext() {
  const context = useContext(CurrentViewContext);
  if (!context) {
    throw new Error('useCurrentView must be used within a CurrentViewProvider');
  }
  return context;
}